if (!customElements.get('chhedas-autoplay-video')) {
  customElements.define('chhedas-autoplay-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.video.muted = true;
      this.video.playsInline = true;
      this.updateSound = () => {
        const audible = !this.video.muted && this.video.volume > 0;
        this.button.textContent = audible ? 'Sound off' : 'Sound on';
        this.button.setAttribute('aria-label', audible ? 'Turn sound off' : 'Turn sound on');
        this.button.setAttribute('aria-pressed', String(audible));
      };
      this.toggleSound = () => {
        const audible = !this.video.muted && this.video.volume > 0;
        this.video.muted = audible;
        if (!audible && this.video.volume === 0) this.video.volume = 1;
        this.updateSound();
        if (this.video.paused) this.video.play().catch(() => {});
      };
      this.button.addEventListener('click', this.toggleSound);
      this.video.addEventListener('volumechange', this.updateSound);
      this.updateSound();
      // Native controls remain available if the browser declines autoplay.
      this.video.play().catch(() => {});
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggleSound);
      this.video?.removeEventListener('volumechange', this.updateSound);
    }
  });
}
